<template>

<div>
  <v-app>

	<div class="main-content minBodyHeight">
	  	<!-- BEGIN TOPBAR -->
		<div class="navbar navbar-fixed-top noBorder">
			<div class="container-fluid header-container">
				<router-link to="/" class="navbar-brand header-image"><img class="img-responsive" src="../static/make/global/images/logo/logo-dark.png"></router-link>
				
				<ul class="profile-container nav">
					<elv-change-view-as-player :viewAsPlayer="viewAsPlayer"/>
				</ul>
				<!--<br-flag-language-selector></br-flag-language-selector>-->
				<br-language-selector></br-language-selector>
				<!--<locale-switcher :locales="localeList"></locale-switcher>&ndash;&gt;-->
				<!--<img src="../static/make/global/images/logo/logo-dark.png" class="br-language-selector" />-->
				
			</div>
			<div class="sub-header-container navbar-default">
				<div class="container-fluid noPadding">
					<div class="navbar-header collapsed-button-container">
						<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
							<span class="sr-only">Toggle navigation</span>
							<span class="icon-bar"></span>
							<span class="icon-bar"></span>
							<span class="icon-bar"></span>
						</button>
					</div>
					
					<div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
						<ul class="sub-header-content">
							<router-link tag="li" class="nav-button" active-class="nav-button-active" to="/" exact><a><i class="icon-home"></i><span>{{ $t('site.nav.home') | allCaps }}</span></a></router-link>
							<!--<router-link tag="li" class="nav-button" active-class="nav-button-active" to="/global/stats"><a><i class="icon-bar-chart"></i><span>GLOBAL</span></a></router-link>-->
							<router-link tag="li" class="nav-button" active-class="nav-button-active" to="/players"><a><i class="icon-user"></i><span>{{ $t('site.nav.players') | allCaps }}</span></a></router-link>
							<router-link tag="li" class="nav-button" active-class="nav-button-active" to="/fellowships"><a><i class="icon-users"></i><span>{{ $t('site.nav.fellowships') | allCaps }}</span></a></router-link>
							<router-link tag="li" class="nav-button" active-class="nav-button-active" to="/tournaments"><a><i class="icon-trophy"></i><span>{{ $t('site.nav.tournaments') | allCaps }}</span></a></router-link>
							<router-link tag="li" class="nav-button" active-class="nav-button-active" to="/contact"><a><i class="icon-note"></i><span>{{ $t('site.nav.contact') | allCaps }}</span></a></router-link>
							<router-link tag="li" class="nav-button" active-class="nav-button-active" to="/faq"><a><i class="icon-bulb"></i><span>{{ $t('site.nav.faq') | allCaps}}</span></a></router-link>
							<router-link tag="li" class="nav-button nav-parent" active-class="nav-button-active" to="/donate"><a><i class="icon-cup"></i><span>{{ $t('site.nav.donate') | allCaps }}</span></a></router-link>

							<div class="sub-header-right">
								<router-link v-if="viewAsPlayer.username && viewAsPlayer.isFriend" v-bind:class="{ 'nav-active': viewAsPlayer.isFriend}" tag="li" class="nav-inactive" active-class="nav-button-active" :to="`/matchmaker/find/fellowship`">        <a><i class="fas fa-handshake"></i><span>{{ "Compatible Fellowships" | allCaps}}</span>            </a></router-link>
								<template v-if="viewAsPlayer.username">
									<router-link v-bind:class="{ 'nav-active': viewAsPlayer.username}" tag="li" class="nav-button-inactive" active-class="nav-button-active" :to="`/player/${viewAsPlayer.server}/${viewAsPlayer.playerId}`">        <a><i class="fas fa-user"></i><span>{{ $t('site.nav.me') | allCaps }}</span>            </a></router-link>
									<router-link v-bind:class="{ 'nav-active': viewAsPlayer.username}" tag="li" class="nav-button-inactive" active-class="nav-button-active" :to="`/fellowship/${viewAsPlayer.server}/${viewAsPlayer.fellowshipId}`"><a><i class="fas fa-users"></i>  <span>{{ $t('site.nav.myFellowship') | allCaps }}</span></a></router-link>
								</template>
								<template v-else>
									<router-link @click.native.prevent.capture="clicked" v-bind:class="{ 'nav-active': viewAsPlayer.username}" tag="li" class="nav-inactive" active-class="nav-button-active" :to="`/player/${viewAsPlayer.server}/${viewAsPlayer.playerId}`">        <a><i class="fas fa-user"></i><span>{{ $t('site.nav.me') | allCaps}}</span>            </a></router-link>
									<router-link @click.native.prevent.capture="clicked" v-bind:class="{ 'nav-active': viewAsPlayer.username}" tag="li" class="nav-inactive" active-class="nav-button-active" :to="`/fellowship/${viewAsPlayer.server}/${viewAsPlayer.fellowshipId}`"><a><i class="fas fa-users"></i>  <span>{{ $t('site.nav.myFellowship') | allCaps}}</span></a></router-link>
								</template>
							</div>
						</ul>
					</div>
				</div>
			</div>
		</div>
	  	<!-- END TOPBAR -->

		<div class="page-content">
			<div id="app">
				<div v-if="ajaxError">
					<v-alert type="error" :value="true">
						Unable to retrieve data from the database server.  API Server might be down if you see this across multiple pages.
						Please retry, if the problem persists please report it via the <router-link to="/contact">contact</router-link> page.
						We do not have automatic monitoring in place yet. Sorry for the inconvenience and thanks for using the site!
					</v-alert>
				</div>
			<router-view :viewAsPlayer="viewAsPlayer"></router-view>  <!-- This is where the SPA Content Goes -->
			</div>
		</div>

		<elv-footer class="footer-position"></elv-footer>
	</div>

	<v-dialog v-model="showSetUserDialog" persistent max-width="500px">
		<!--<v-btn color="primary" dark slot="activator">Open Dialog</v-btn>-->
		<v-card>
			<v-card-title>
				<span class="headline">{{ $t('site.playerSelection.headline') }}</span>
				<small>{{ $t('site.playerSelection.description') }}</small>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout wrap>
						<elv-player-search-box :emitViewAsPlayer="true" />
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="blue darken-1" flat @click.native="showSetUserDialog = false">{{ $t('site.common.cancel') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

  </v-app>
</div>

</template>

<script>
	import Vue from 'vue';
	import Vuetify from 'vuetify';
	import ElvViewAsPlayer from "./components/ElvViewAsPlayer";
    import ElvChangeViewAsPlayer from './components/ElvChangeViewAsPlayer';
    import ElvChangeViewAsPlayerDialog from "./components/ElvChangeViewAsPlayerDialog"
	import ElvPlayerSearchBox from "./components/ElvPlayerSearchBox"
	import axios from 'axios';
	import 'babel-polyfill'
    import ElvFooter from "@/components/ElvFooter"
    import BrLanguageSelector from "@/components/BRLanguageSelector"
    import LocaleSwitcher from "@/components/LocaleSwitcher"
	let translationData = require("./lib/translation-data");
	let elvenStats = require('./lib/elven-stats');

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

    Vue.use(Vuetify);
    Vue.use(require('vue-moment'));
	window.Event = new Vue();

	export default {
		components: {
            LocaleSwitcher,
            BrLanguageSelector,
            ElvFooter,
            ElvPlayerSearchBox,
            ElvChangeViewAsPlayerDialog,
            ElvViewAsPlayer,ElvChangeViewAsPlayer},
			FontAwesomeIcon,
		name: 'App',
		data() {
			return {
			    ajaxError: false,
				viewAsPlayer: { username: "" },
                showSetUserDialog: false,
				localeList: translationData.getLocaleCodes()
			}
		},
		methods: {
            clicked: function(e) {
                    e.preventDefault()
					this.showSetUserDialog = true;
            }
		},
		created() {
		    this.ajaxError = false;

			Event.$on("viewAsPlayer", (data) => {
                this.showSetUserDialog = false;
                console.log("viewAsPlayer received in app.vue");
                this.viewAsPlayer = data;
                setPlayerCookie(data);

                try {
                    axios.put(`/api/player/${this.viewAsPlayer.server}/${this.viewAsPlayer.playerId}/viewAsSet/`).then(
                        (response) => {
                            console.log("Sent request");
                        }).catch((err) => {
                        console.log("request failed");
                    })
                }catch(err) {
                    console.error("failed to viewasset", err);
                }

			});

            Event.$on("ajaxError", (data) => {
                this.ajaxError = true;
            });

			var playerInfo = getPlayerCookie();
			console.log("cookie info: ", playerInfo);
			if( playerInfo && playerInfo.server && playerInfo.playerId ) {
                this.viewAsPlayer = playerInfo;

                axios.get(`/api/player/${this.viewAsPlayer.server}/${this.viewAsPlayer.playerId}`).then(( response ) => {
                    //console.log("ENSURING USER HASNT CHANGED FELLOWSHIPS", response);
                    response.data.serverName = elvenStats.mapDomainAndServerName(this.viewAsPlayer.server);
                    this.viewAsPlayer = response.data;
                    setPlayerCookie(this.viewAsPlayer);
                }).catch(( err ) => {
                    console.log(err);
                    this.ajaxDone = true;
                    //Event.$emit("ajaxError", "Error");
                });
            }
	    },
        beforeRouteUpdate ( to, from , next ) {
            console.log('Reusing this component.')
            this.ajaxError = false;
            next()
        }
	}

	function setPlayerCookie(player) {
	    console.log("in set cookie");
	    	console.log(player);
	    setCookie( "username", player.username, 50 );
	    setCookie( "playerId", player.playerId, 50 );
	    setCookie( "fellowshipId", player.fellowshipId, 50 );
	    setCookie( "fellowship", player.fellowship, 50 );
	    setCookie( "avatar", player.avatar, 50 );
	    setCookie( "server", player.server, 50 );
	    setCookie( "serverName", player.serverName, 50 );
	    setCookie( "isFriend", player.isFriend, 50 );
    }

	function getPlayerCookie(player) {
	    return {
	        username: getCookie("username"),
            playerId: getCookie("playerId"),
            fellowshipId: getCookie("fellowshipId"),
            fellowship: getCookie("fellowship"),
            avatar: getCookie("avatar"),
            server: getCookie('server'),
            serverName: getCookie('serverName'),
			isFriend: getCookie('isFriend') === "true"
        }
    }

    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    function eraseCookie(name) {
        document.cookie = name+'=; Max-Age=-99999999;';
    }
</script>

<style>
	.btn.btn-sm:hover {
		color: white;
	}

	.negativeValue {
		color: red;
	}
	.positiveValue {
		color: green;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue